<!--
 * @Author: 汪俊洪
 * @Date: 2022-02-28 16:53:16
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-03-09 10:02:57
 * @Description: 新增模板
-->
<template>
  <div>
    <div class="save">
      <el-input
        v-model="dataForm.name"
        placeholder="请输入模板名称"
        maxlength="50"
        show-word-limit
        clearable
      ></el-input>
      <el-button class="save-btn" @click="save" type="primary"
        >保存模板</el-button
      >
    </div>
    <el-transfer
      :titles="['所有列', '自定义列']"
      ref="transfer"
      v-model="value"
      :data="list"
      :props="{
        key: 'id'
      }"
      target-order="push"
      @right-check-change="rightCheckChange"
    >
      <span slot-scope="{ option }">
        {{ option.name }} [{{ option.code }}]
      </span>
      <div class="right-footer" slot="right-footer">
        <el-button
          class="btn"
          type="primary"
          @click="toUp"
          :disabled="!rightArr.length"
          size="mini"
        >
          向上
        </el-button>
        <el-button
          class="btn"
          type="primary"
          @click="toDown"
          :disabled="!rightArr.length"
          size="mini"
        >
          向下
        </el-button>
      </div>
    </el-transfer>
  </div>
</template>

<script>
export default {
  props: {
    sysListCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dataForm: {
        name: ''
      },
      list: [],
      value: [],
      rightArr: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取字段列表
    getList () {
      this.$http
        .get(
          `/help/user-list-mgmt/v1/sys-lists/${this.sysListCode}/sys-list-fields`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = res.data
          }
        })
    },
    // 右侧点击选中
    rightCheckChange (a) {
      this.rightArr = [...a]
    },
    // 交换位置
    changIndex (key, num, arr) {
      let index = -1
      arr.some((v, i) => {
        if (v === key) {
          index = i
          return true
        }
        return false
      })
      const _num = index + num // 当前要操作的位置
      if (_num > -1) {
        const target = this.value.splice(index, 1)
        this.value.splice(_num, 0, target[0])
        this.value = [...this.value]
      }
    },
    // 向上
    toUp () {
      const arr = [...this.value]
      this.rightArr.forEach((key) => {
        this.changIndex(key, -1, arr)
      })
    },
    // 向下
    toDown () {
      // 要获取最开始移动的数据
      const arr = [...this.value]
      for (let i = this.rightArr.length - 1; i >= 0; i--) {
        this.changIndex(this.rightArr[i], 1, arr)
      }
    },
    // 保存模板
    save () {
      if (!this.dataForm.name) {
        this.$message.error('请输入模板名称')
        return
      }
      if (!this.value.length) {
        this.$message.error('请选择自定义列')
        return
      }
      const obj = {
        sysListCode: this.sysListCode,
        name: this.dataForm.name,
        listFieldIdList: this.value
      }
      this.$http.post('/help/user-list-mgmt/v1/user-list-templates', obj).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message.success(res.message)
          this.$emit('success')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.right-footer {
  padding: 3px;
}

.btn {
  padding: 4px 8px;
}

.save {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;

  .save-btn {
    margin-left: 12px;
  }
}
</style>
